module.exports = {
  www: 'https://www.sasmango.com/sas/',
  api: 'https://api.sasmango.com/',
  dev: 'https://dev.sasmango.com/',
  leg: 'https://legacy.sasmango.com/',
  client: 'https://cli.sasmango.com/',
  zip: 'https://api.zipaddress.net?zipcode=',
  gmap: 'https://maps.google.co.jp/maps/search/'
}
